import Vue from 'vue';
import App from './app/app.vue';
import router from './app/app-routes';
import { Flags } from './env';

Vue.config.productionTip = false;
Vue.prototype.$isNine = Flags.isNine;

const vue = new Vue({
  router,
  render: h => h(App),
});

vue.$mount('#app');
